import { createContext } from 'react';

const NotifierContext = createContext(null);

export default NotifierContext;